<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Editar Módulo</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.app_id"
                  :items="applications"
                  :rules="applicationRules"
                  item-value="id"
                  item-text="name"
                  label="Aplicación"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  name="description"
                  label="Descripción"
                  :rules="descriptionRules"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-switch v-model="editedItem.active" label="Estado"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue darken-1"
          :loading="isLoading"
          :disabled="isLoading"
          @click="save()"
          text
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "EditModuleDialog",

  props: {
    module: Object,
  },

  data: () => ({
    dialog: false,
    isValidFormDialog: false,
    nameRules: [(v) => !!v || "Campo requerido"],
    descriptionRules: [(v) => !!v || "Campo requerido"],
    applicationRules: [(v) => !!v || "Campo requerido"],
    isLoading: false,
    editedItem: {
      name: "",
      description: "",
      active: true,
      app_id: "",
    },
    defaultItem: {
      name: "",
      description: "",
      active: true,
      app_id: "",
    },
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplications"];
    },
    validationErrors() {
      return this.$store.getters["modules/getValidationErrors"];
    },
  },

  watch: {
    module(val) {
      if (val && val.name) {
        this.dialog = true;
        this.editedItem = val;
      }
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("modules/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await this.$store.dispatch("modules/updateModule", this.editedItem);
          this.showSnack("green", "Módulo actualizado");
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
